<div class="app-layout">
  <!-- HEADER - Full Width -->
  <sca-menu-desktop class="app-header" [class.home-page]="isHomePage()">
    <!-- Zona izquierda: Logo y título -->
    <ng-container left>
      <div class="menu-logo" routerLink="/home" style="cursor: pointer;">
        <img src="assets/logo_argo.svg" alt="Argo" class="logo-icon" />
        <span class="logo-text">{{ title }}</span>
      </div>
      
      <!-- Menu items -->
      <sca-menu-desktop-item routerLink="/test" routerLinkActive="active">
        Tests
      </sca-menu-desktop-item>
      <sca-menu-desktop-item routerLink="/module-federation" routerLinkActive="active">
        Module Federation
      </sca-menu-desktop-item>
      <sca-menu-desktop-item routerLink="/webcomponent" routerLinkActive="active">
        WebComponent
      </sca-menu-desktop-item>
    </ng-container>

    <!-- Zona derecha: Session timer y usuario -->
    <ng-container right>
      <!-- Session Timer -->
      <div class="session-timer" *ngIf="logged()" [class.expiring]="almostExpired()">
        <span class="material-icons">schedule</span>
        <span class="timer-text">{{ secondsToLogout() }}s</span>
      </div>

      <!-- Loading Skeleton durante autenticación -->
      <div class="auth-loading" *ngIf="isAuthenticating() && !logged()">
        <div class="skeleton-avatar"></div>
        <div class="skeleton-text"></div>
      </div>

      <!-- User Avatar con dropdown -->
      <sca-avatar *ngIf="logged()" [username]="user().preferred_username || user().email || 'Usuario'">
        <h2 class="dropdown-title">Gestiona tu cuenta</h2>
        <sca-list>
          <sca-list-item>
            <sca-icon icon="chevron_right" />
            <p>Mis datos</p>
          </sca-list-item>
          <sca-list-item>
            <sca-icon icon="chevron_right" />
            <p>Contraseña y preferencias</p>
          </sca-list-item>
          <sca-list-item (click)="logout()" style="cursor: pointer;">
            <sca-icon icon="logout" />
            <p>Cerrar sesión</p>
          </sca-list-item>
        </sca-list>
      </sca-avatar>

      <!-- Login Button -->
      <button sca-button variant="border" *ngIf="!logged() && !isAuthenticating()" (click)="login()">
        Iniciar sesión
      </button>
    </ng-container>
  </sca-menu-desktop>

  <!-- CONTENT AREA -->
  <div class="content-wrapper" [class.home-page]="isHomePage()">
    <!-- PAGE CONTENT -->
    <main class="page-content" [class.home-page]="isHomePage()">
      <div [scaContainer]="'fluid'" class="content-container" [class.home-page]="isHomePage()">
        <!-- HEADER SECTION -->
        <header class="header" *ngIf="!isHomePage()">
          <!-- Breadcrumbs -->
          <sca-breadcrumb>
            <a sca-breadcrumb-item routerLink="/">Home</a>
            <a sca-breadcrumb-item [active]="true">{{ getCurrentRoute() }}</a>
          </sca-breadcrumb>
          
          <!-- Module Title -->
          <sca-module-title>
            <h1>Argo v8 Playground</h1>
          </sca-module-title>
        </header>
        
        <!-- SECTION DETAILS: Tabs + Content -->
        <section class="section-details" *ngIf="isInTestSection()">
          <!-- Horizontal Chips (visible >= 1400px) -->
          <div class="tabs-horizontal">
            <sca-chip 
              size="small"
              [selected]="getCurrentRoute() === 'test/auth'"
              (click)="onTabChange('test/auth')">
              Authentication
            </sca-chip>
            <sca-chip 
              size="small"
              [selected]="getCurrentRoute() === 'test/common'"
              (click)="onTabChange('test/common')">
              Common
            </sca-chip>
            <sca-chip 
              size="small"
              [selected]="getCurrentRoute() === 'test/config'"
              (click)="onTabChange('test/config')">
              Configuration
            </sca-chip>
            <sca-chip 
              size="small"
              [selected]="getCurrentRoute() === 'test/devlogs'"
              (click)="onTabChange('test/devlogs')">
              DevLogs
            </sca-chip>
            <sca-chip 
              size="small"
              [selected]="getCurrentRoute() === 'test/http-interceptors'"
              (click)="onTabChange('test/http-interceptors')">
              HTTP Interceptors
            </sca-chip>
            <sca-chip 
              size="small"
              [selected]="getCurrentRoute() === 'test/multilanguage'"
              (click)="onTabChange('test/multilanguage')">
              Multilanguage
            </sca-chip>
            <sca-chip 
              size="small"
              [selected]="getCurrentRoute() === 'test/navigation'"
              (click)="onTabChange('test/navigation')">
              Navigation
            </sca-chip>
            <sca-chip 
              size="small"
              [selected]="getCurrentRoute() === 'test/security'"
              (click)="onTabChange('test/security')">
              Security
            </sca-chip>
            <sca-chip 
              size="small"
              [selected]="getCurrentRoute() === 'test/seo'"
              (click)="onTabChange('test/seo')">
              SEO
            </sca-chip>
            <sca-chip 
              size="small"
              [selected]="getCurrentRoute() === 'test/session'"
              (click)="onTabChange('test/session')">
              Session
            </sca-chip>
            <sca-chip 
              size="small"
              [selected]="getCurrentRoute() === 'test/traces'"
              (click)="onTabChange('test/traces')">
              Traces
            </sca-chip>
            <sca-chip 
              size="small"
              [selected]="getCurrentRoute() === 'test/websocket'"
              (click)="onTabChange('test/websocket')">
              WebSocket
            </sca-chip>
             <sca-chip 
                size="small"
                [selected]="getCurrentRoute() === 'test/valid-forms'"
                (click)="onTabChange('test/valid-forms')">
                Valid Forms
              </sca-chip>
          </div>

          <!-- Vertical Tabs (visible < 1400px) -->
          <sca-tabs 
            orientation="vertical" 
            [value]="getCurrentRoute()"
            class="tabs-vertical">
            <sca-tab value="test/auth" (click)="onTabChange('test/auth')">
              <p scaTabTitle>
                <span class="material-icons">vpn_key</span>
                Authentication
              </p>
            </sca-tab>
            <sca-tab value="test/common" (click)="onTabChange('test/common')">
              <p scaTabTitle>
                <span class="material-icons">extension</span>
                Common
              </p>
            </sca-tab>
            <sca-tab value="test/config" (click)="onTabChange('test/config')">
              <p scaTabTitle>
                <span class="material-icons">settings</span>
                Configuration
              </p>
            </sca-tab>
            <sca-tab value="test/devlogs" (click)="onTabChange('test/devlogs')">
              <p scaTabTitle>
                <span class="material-icons">bug_report</span>
                DevLogs
              </p>
            </sca-tab>
            <sca-tab value="test/http-interceptors" (click)="onTabChange('test/http-interceptors')">
              <p scaTabTitle>
                <span class="material-icons">http</span>
                HTTP Interceptors
              </p>
            </sca-tab>
            <sca-tab value="test/multilanguage" (click)="onTabChange('test/multilanguage')">
              <p scaTabTitle>
                <span class="material-icons">translate</span>
                Multilanguage
              </p>
            </sca-tab>
            <sca-tab value="test/navigation" (click)="onTabChange('test/navigation')">
              <p scaTabTitle>
                <span class="material-icons">explore</span>
                Navigation
              </p>
            </sca-tab>
            <sca-tab value="test/security" (click)="onTabChange('test/security')">
              <p scaTabTitle>
                <span class="material-icons">security</span>
                Security
              </p>
            </sca-tab>
            <sca-tab value="test/seo" (click)="onTabChange('test/seo')">
              <p scaTabTitle>
                <span class="material-icons">search</span>
                SEO
              </p>
            </sca-tab>
            <sca-tab value="test/session" (click)="onTabChange('test/session')">
              <p scaTabTitle>
                <span class="material-icons">sync</span>
                Session
              </p>
            </sca-tab>
            <sca-tab value="test/traces" (click)="onTabChange('test/traces')">
              <p scaTabTitle>
                <span class="material-icons">timeline</span>
                Traces
              </p>
            </sca-tab>
            <sca-tab value="test/websocket" (click)="onTabChange('test/websocket')">
              <p scaTabTitle>
                <span class="material-icons">sync_alt</span>
                WebSocket
              </p>
            </sca-tab>
             <sca-tab value="test/valid-forms" (click)="onTabChange('test/valid-forms')">
               <p scaTabTitle>
                 <span class="material-icons">fact_check</span>
                 Valid Forms
               </p>
             </sca-tab>
          </sca-tabs>
          
          <!-- Content Area -->
          <div class="content-area">
            <router-outlet></router-outlet>
          </div>
        </section>
        
        <!-- NO TABS SECTION (for module-federation and webcomponent) -->
        <section class="section-no-tabs" *ngIf="!isInTestSection()">
          <router-outlet></router-outlet>
        </section>
      </div>
    </main>

    <!-- FOOTER -->
    
  </div>

  <sca-footer-bottom>
  <!-- Texto y enlaces, cada hijo directo para flex + gap -->
  <span footer-text>© 2024 SegurCaixa Adeslas</span>
  <a footer-text href="/mapa-web">Mapa Web</a>
  <a footer-text href="/aviso-legal">Aviso legal y privacidad</a>
  <a footer-text href="/accesibilidad">Accesibilidad</a>
  <a footer-text href="/cookies">Política de Cookies</a>

  <!-- Slot de selector personalizado -->
  
</sca-footer-bottom>
</div>
